// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToolReplace_container__VbZw4 {
  max-width: 400px;
  margin: 40px auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px #0002;
  padding: 32px 24px;
  text-align: center;
}
.ToolReplace_button__oUwJP {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 18px;
  font-size: 1em;
  cursor: pointer;
  margin-top: 16px;
}
select {
  padding: 6px 12px;
  font-size: 1em;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Tools/ToolReplace.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".container {\r\n  max-width: 400px;\r\n  margin: 40px auto;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 8px #0002;\r\n  padding: 32px 24px;\r\n  text-align: center;\r\n}\r\n.button {\r\n  background: #1976d2;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 6px 18px;\r\n  font-size: 1em;\r\n  cursor: pointer;\r\n  margin-top: 16px;\r\n}\r\nselect {\r\n  padding: 6px 12px;\r\n  font-size: 1em;\r\n  border-radius: 4px;\r\n  border: 1px solid #ccc;\r\n  margin-top: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ToolReplace_container__VbZw4`,
	"button": `ToolReplace_button__oUwJP`
};
export default ___CSS_LOADER_EXPORT___;
